import { PREDICAMENT_STATE_YES } from "core/consts";
import { ONTOLOGIES } from "core/model/utils/ontologies";
import { RADIO_WHITE_BACKGROUND } from "ds_legacy/materials/colors";
import { padding, sizing } from "ds_legacy/materials/metrics";
import { FONT_SIZE_14 } from "ds_legacy/materials/typography";
import {
  DatePickerWithLabel,
  LARGE_INPUT_MIN_WIDTH,
  LARGE_INPUT_WIDTH,
  Section,
  SectionRow,
  TextInputWithLabel,
  YesNoRadioWithLabel,
} from "dsl/ecosystems/PatientForms/components";
import { OntologyRadioGroupV2 } from "dsl/molecules/OntologyRadioGroup";
import { useTranslations } from "translations";

export const SectionSeven = () => {
  const translations = useTranslations();

  return (
    <Section
      title={
        translations.patientForms.drvGeneralForm.sectionSix.insuranceInformation
      }
    >
      <SectionRow customPadding={padding(0, 0, 2)}>
        <TextInputWithLabel
          elementName="insurance_name"
          isLarge
          label={
            translations.patientForms.drvGeneralForm.sectionSix.insuranceName
          }
        />
      </SectionRow>
      <OntologyRadioGroupV2
        elementName="insurance_type"
        formControlLabelSx={{ marginLeft: 0, paddingBottom: sizing(0.5) }}
        formLabelSx={{
          fontSize: FONT_SIZE_14,
          padding: padding(1, 0),
        }}
        label={
          translations.patientForms.drvGeneralForm.sectionSix.patientInsurance
        }
        radioSx={RADIO_WHITE_BACKGROUND}
        type={ONTOLOGIES.INSURANCE_TYPE}
      />
      <YesNoRadioWithLabel
        elementName="patient_unable_to_work_before_hospitalization"
        label={
          translations.patientForms.drvGeneralForm.sectionSix
            .subtitleHospitalStay
        }
        shouldStartWithNo
        sideMutation={(_value, mutate) => {
          mutate(null, "patient_unable_to_work_before_hospitalization_date");
        }}
        subForms={{
          [PREDICAMENT_STATE_YES]: (
            <DatePickerWithLabel
              elementName="patient_unable_to_work_before_hospitalization_date"
              inputSx={{
                minWidth: LARGE_INPUT_MIN_WIDTH,
                width: LARGE_INPUT_WIDTH,
              }}
              isBold
              label={
                translations.patientForms.drvGeneralForm.sectionSix.sinceDate
              }
              withFlatModel
            />
          ),
        }}
      />
    </Section>
  );
};
